import HttpRequest from "./HttpRequest";

export default class AssetService {

  static ALL_URL = 'ton/v1/assets';
  static ALL_TAGS_URL = 'ton/v1/assets/tags';
  static ALL_INTERNAL_BARCODES_URL = 'ton/v1/assets/internalBarcodes';

  httpRequest = new HttpRequest();

  count() {
    return this.httpRequest.get(`${AssetService.ALL_URL}/count`);
  }

  findByEpc(epc) {
    return this.httpRequest.get(`${AssetService.ALL_URL}/epcs/${epc}`);
  }

  findByLsd(query){
    return this.httpRequest.get(`${AssetService.ALL_URL}/lsd${query}`)
  }
  findBySerial(serial) {
    return this.httpRequest.get(`${AssetService.ALL_URL}/serials/${serial}`);
  }

  findStatesByEpc(epc, page, pageSize) {
    return this.httpRequest.get(`${AssetService.ALL_URL}/epcs/${epc}/states?page=${page}&size=${pageSize}&sort=stateDate,DESC`);
  }

  findAllPhotos(assetId) {
    return this.httpRequest.get(`${AssetService.ALL_URL}/${assetId}/photos`);
  }

  validateEpc(assetId, epcs) {
    return this.httpRequest.post(`ton/v1/assets/${assetId}/validate/epcs/`, {epcs: epcs});
  }
}



// WEBPACK FOOTER //
// ./src/services/AssetService.js